export default {
    driver_performance_events_driver_id: "DriverID",
    driver_performance_events_driver_name: "Driver",
    driver_performance_events_driver_supervisor: "Supervisor",
    driver_performance_events_driver_tags: "Tags",
    driver_performance_events_driver_no_driver_info: "No driver information available.",
    driver_performance_events_change_driver: "Change Driver",
}